import { IconProps } from "../../../types/style";

const DolorGreen = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M9.64998 4.45975V7.03476C9.64998 8.57476 8.76998 9.23474 7.44998 9.23474H3.05498C2.82998 9.23474 2.61498 9.21477 2.41498 9.16977C2.28998 9.14977 2.16998 9.11477 2.05998 9.07477C1.30998 8.79477 0.85498 8.14476 0.85498 7.03476V4.45975C0.85498 2.91975 1.73498 2.25977 3.05498 2.25977H7.44998C8.56998 2.25977 9.37498 2.73476 9.58998 3.81976C9.62498 4.01976 9.64998 4.22475 9.64998 4.45975Z"
          fill={color}
        />
        <path
          d="M11.15 5.95981V8.53482C11.15 10.0748 10.27 10.7348 8.95004 10.7348H4.55504C4.18504 10.7348 3.85004 10.6848 3.56004 10.5748C2.96504 10.3548 2.56004 9.89983 2.41504 9.16983C2.61504 9.21483 2.83004 9.2348 3.05504 9.2348H7.45004C8.77004 9.2348 9.65004 8.57482 9.65004 7.03482V4.45981C9.65004 4.22481 9.63004 4.01482 9.59004 3.81982C10.54 4.01982 11.15 4.68981 11.15 5.95981Z"
          fill={color}
        />
        <path
          d="M5.24994 7.07019C5.97895 7.07019 6.56995 6.4792 6.56995 5.75018C6.56995 5.02117 5.97895 4.43018 5.24994 4.43018C4.52092 4.43018 3.92993 5.02117 3.92993 5.75018C3.92993 6.4792 4.52092 7.07019 5.24994 7.07019Z"
          fill={color}
        />
        <path
          d="M2.39001 4.625C2.18501 4.625 2.01501 4.795 2.01501 5V6.5C2.01501 6.705 2.18501 6.875 2.39001 6.875C2.59501 6.875 2.76501 6.705 2.76501 6.5V5C2.76501 4.795 2.60001 4.625 2.39001 4.625Z"
          fill={color}
        />
        <path
          d="M8.10498 4.625C7.89998 4.625 7.72998 4.795 7.72998 5V6.5C7.72998 6.705 7.89998 6.875 8.10498 6.875C8.30998 6.875 8.47998 6.705 8.47998 6.5V5C8.47998 4.795 8.31498 4.625 8.10498 4.625Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default DolorGreen;
